import { render, staticRenderFns } from "./ledgerRole.vue?vue&type=template&id=7c489cf0&scoped=true&"
import script from "./ledgerRole.vue?vue&type=script&lang=js&"
export * from "./ledgerRole.vue?vue&type=script&lang=js&"
import style0 from "./ledgerRole.vue?vue&type=style&index=0&id=7c489cf0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c489cf0",
  null
  
)

export default component.exports